module.exports = __webpack_public_path__ + "img/icon-tri-searchtrivia.767ddae0.png";